import { ValidatorService } from '../../../../services/tools/validator.service';
import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
declare var $;

@Component({
  selector: 'app-select2-groups',
  templateUrl: './select2-groups.component.html',
  styleUrls: ['./select2-groups.component.scss']
})
export class Select2GroupsComponent implements OnInit {

  @Input() public default: string;
  @Input() public model: any;
  @Input() public options: any;
  @Input() public error: any; 
  @Input() public element: string;
  @Input() public response: string;
  @Input() public disabled: boolean = false;
  private data: any[];

  @Output() public SelectCallback: EventEmitter<any> = new EventEmitter;
  constructor(private validatorService: ValidatorService) {
  }

  ngOnInit() {

    if (this.element) {

      // se debe colocar un timeout para que de tiempo de que se cargue el DOM
      setTimeout(() => {
        // iniciando input y recibiendo model
        this.input().select2({
          'data': this.getData()
        });

        // enviamos al padre nuestro valor si es que hay cambios dentro del componente
        this.input().on('select2:select', e => {
          this.emit();
        });
      }, 500);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.options){
      if (changes.options.firstChange == false) {
        this.rebuild();
      }
    }
    if(changes.model){
      if (changes.model.firstChange == false) {
        this.rebuild();
        return;
      }
    }
  }

  rebuild() {
    this.input().empty();
    this.input().select2({
      'data': this.getData()
    });
  }

  getData() {
    this.data = $.map(this.options, (group) => {
      $.map(group.children, (obj) => {
        if(this.model && this.model[group['key']] == obj[group['key']]) {
          obj.selected = true;
        } else {
          obj.selected = false;
        }
  
        obj.id = this.doUniqueValue(group, obj);
        obj.text = obj[group.label];
        return obj;
      })
      return group;
    });
    this.data.unshift({
      id: -1,
      text: this.default
    });
    return this.data;
  }

  // emite la respuest al callback
  emit() {
    const response = this.getResponse();
    this.SelectCallback.emit(response);
  }

  // regresamos valor actual del select en key o en model
  getResponse() {
    const value = this.undoUniqueValue(this.input().val());
    return this.search(value);
  }

  search(value) {
    let find = {};

    for (const group of this.options) {
      for (const option of group.children) {
        if (value.group == group.text && value.option == option[group.key]) {
          find = option;
        }
      }
    }
    return find;
  }

  input() {
    return $('#' + this.element);
  }

  doUniqueValue(group, option) {
    return this.getUniqueValueSelected(group, option);
  }
  undoUniqueValue(value) {
    const value_array = value.split('-');
    const group_name = value_array[0];
    const option_id = value_array[1];
    return {
      'group': group_name,
      'option': option_id
    };
  }
  getUniqueValueSelected(group, option) {
    return group.text + '-' + option[group.key];
  }

}



// WEBPACK FOOTER //
// ./src/app/components/tools/select2/select2-groups/select2-groups.component.ts